import type { LineChartReportCardProps } from '../../AnalyticsDashboard.types'
import { useLineChartReportCard } from '../useLineChartReportCard'

const reportId = 'contributions_per_type'

type Options = {
  type: 'total' | 'shop' | 'memberships'
  headerLabel?: string
}

const filters: Record<Options['type'], Record<string, string>> = {
  total: {},
  shop: {
    shop_metrics:
      'shop_orders,donations,twitch_gifts,giveaway_links,sample_orders,orders_twitch_gifts_purchases,orders_twitch_gifts_redeems',
  },
  memberships: {
    memberships_metrics:
      'memberships_subscriptions,memberships_message_tips,memberships_locked_messages,memberships_subscription_gifts,memberships_twitch_gifts',
  },
}

const headerLabelMap: Record<Options['type'], string> = {
  total: 'Total orders',
  shop: 'Shop orders',
  memberships: 'Memberships transactions',
}

const headerTooltipTitleMap: Record<Options['type'], string> = {
  total: 'Total orders',
  shop: 'Shop orders',
  memberships: 'Memberships transactions',
}

const headerTooltipDescriptionMap: Record<Options['type'], string> = {
  total: 'Number of all contributions',
  shop: 'Number of shop orders, donations, giveaways and gifts.',
  memberships:
    'Number of membership-related transactions: new subscriptions, renewals, upgrades, tips, locked DMs, gifted subscriptions, and Twitch gifts.',
}

export const useContributionsPerTypeReportCard = ({
  type,
  headerLabel,
}: Options): LineChartReportCardProps => {
  return useLineChartReportCard({
    reportId,
    headerLabel: headerLabel ?? headerLabelMap[type],
    headerTooltipTitle: headerTooltipTitleMap[type],
    headerTooltipDescription: headerTooltipDescriptionMap[type],
    filters: filters[type],
  })
}
